module.exports = __webpack_public_path__ + "d5df689b4799040bbec9202cf3793173.svg";